import React from 'react';
import { Delete } from '@gjensidige/builders-icons';
import { Button, Modal, Title } from '@gjensidige/builders-components';

interface AddInputsModalProps {
  isOpen: boolean;
  modalHeader: string;
  secondaryButtonLabel: string;
  modalBody: React.ReactNode;
  onModalClose: () => void;
  secondaryButtonAction: () => void;
}
export const DeleteConfirmationModal: React.FC<AddInputsModalProps> = ({
  isOpen,
  modalHeader,
  modalBody,
  secondaryButtonLabel,
  onModalClose,
  secondaryButtonAction
}: AddInputsModalProps) => {
  return (
    <Modal
      aria-label="Ta bort övrig byggnad"
      className="delete-input-modal"
      open={isOpen}
      closeLabel="Avbryt att ta bort byggnad"
      strict={true}
      onClick={onModalClose}
      size="sm"
    >
      <div className="delete-modal-confirm">
        <Title as="h2" size="4">{modalHeader}</Title>
        {modalBody}
        <div className="mt-3 delete-footer">
          <Button
            variant="secondary"
            icon={<Delete />}
            iconPosition="left"
            onClick={secondaryButtonAction}
            className="align-center-lg"
          >
            {secondaryButtonLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
